import React from 'react'

const index = () => <div>Call Center</div>

export default index
